import Vue from "vue";
import VueMatomo from "vue-matomo";

export default ({ app }) => {
  const user = app.store.getters["Profile/getUser"];
  let userId = "";
  let preInitActions = [];
  if (user && user.salesforceId) {
    userId = user.salesforceId;
    preInitActions = [
      ["setCustomDimension", 1, user.companyName],
      ["setCustomDimension", 2, `${user.firstName} ${user.lastName}`],
      ["setCustomDimension", 3, user.subscriptions],
      ["setCustomDimension", 4, user.trials],
    ];
  }

  Vue.use(VueMatomo, {
    host: app.$config.matomoURL,
    siteId: app.$config.matomoSiteId,
    userId,
    trackInitialView: false,
    preInitActions,
  });
};
